// SalesShark — English
const en = {
    code: "en",
    label: "English",
    short: "EN",
    flag: "🇬🇧",
    htmlLang: "en",
    nav: {
        home: "Home",
        services: "Services",
        about: "About",
        references: "References",
        contact: "Contact",
        faq: "FAQ",
        consultation: "Free consultation",
    },
    hero: {
        eyebrow: "International Sales Agency",
        headingA: "Every minute you don't choose us",
        headingB: "your competitors take the lead.",
        subheading:
            "Predictable, measurable sales pipeline from target-market selection to signed contracts — built on our proprietary company database, targeted email campaigns and multilingual outbound calls.",
        ctaPrimary: "Free consultation",
        ctaSecondary: "Our services",
        marketsLabel: "Active markets",
        markets: [
            { code: "HU", name: "Hungary" },
            { code: "SK", name: "Slovakia" },
            { code: "CZ", name: "Czechia" },
            { code: "AT", name: "Austria" },
        ],
    },
    quickServices: {
        eyebrow: "What we offer",
        heading: "Nine capabilities, one unified sales engine.",
        subheading:
            "From company database to signed contract — every step with the same team.",
        items: [
            "Company database by country",
            "Appointment scheduling",
            "Cold calling",
            "Telemarketing",
            "Staff placement",
            "Market expansion",
            "Branding",
            "Marketing",
            "Social Media",
        ],
    },
    results: {
        eyebrow: "SalesShark",
        heading: "Results are what matter.",
        bullets: [
            "SalesShark is a results-driven customer acquisition team: we build predictable, measurable pipeline from target-market selection all the way to signed contracts.",
            "Our core asset: a proprietary, country-structured company database (HU / SK / CZ / AT) — the foundation for targeted email campaigns and outbound calls that deliver qualified meetings, and a dedicated SALES representative who closes the deals.",
            "Languages: Hungarian, Slovak, Czech, English, German.",
            "We believe in the power of human relationships: trust, honest communication and consistent follow-up beat any „trick” — every time.",
        ],
        ctaPrimary: "Free consultation",
        ctaSecondary: "Contact",
    },
    detailedServices: {
        eyebrow: "Our services",
        heading: "One clear process, seven revenue-driving modules.",
        subheading:
            "From company database to monthly report — every module is part of a single unified sales engine.",
        ctaMore: "Learn more",
        items: [
            { title: "Company database HU / SK / CZ / AT", text: "Company lists with filters and contact details." },
            { title: "Email marketing", text: "Mass email delivery + meeting-booking CTA + reporting." },
            { title: "Outbound calling", text: "Cold calls and telemarketing in HU / SK / CZ / EN / DE." },
            { title: "Staff placement", text: "Short and long-term sales resources on demand in HU / SK / CZ / EN / DE using our system, plus existing customer care." },
            { title: "Marketing + PPC", text: "Branding, videos, creatives, visual identity, promotional materials, business cards, social media campaign planning and execution." },
            { title: "Expansion support (HU / SK / CZ / AT)", text: "Market research, company formation, bank account, other administrative help." },
            { title: "Monthly reports", text: "Statuses, KPIs, next steps and a regular summary." },
        ],
    },
    problems: {
        eyebrow: "Which one is you?",
        heading: "Tell us!",
        subheading:
            "If any of the situations below sounds familiar, we can probably work together.",
        cta: "Free consultation",
        items: [
            "I have a great product/service but I want more customers.",
            "I want to expand into another country.",
            "I need a professional marketer.",
            "I have no visibility into what my sales rep is doing — how many companies did we actually call?",
            "I need a new sales colleague.",
            "I want to reach decision-makers, not generic contacts.",
            "I don't have time to search for prospects and cold-call every day.",
            "I want solutions, not fluff.",
            "I don't invest enough time in my existing clients.",
        ],
    },
    references: {
        eyebrow: "References",
        headingA: "Our partners' successes",
        headingB: "are our most important reference.",
        statBadge: "50+ partners · 4 markets · 5 languages",
        verifiedBadge: "Verified",
        items: [
            { company: "WHC SLOVAKIA", role: "CEO", text: "We really appreciate the team's attitude, accuracy and their focus on real business outcomes. SalesShark is a partner any growth-oriented company can confidently entrust part or all of their sales process to." },
            { company: "iNTRETECH", role: "CEO", text: "Working with Antal and Antónia, we found a partner that creates real value inside our sales process. The quality of the outreach, the transparency of reporting and the team's expertise confirmed our belief that data-driven sales is now essential." },
            { company: "MOTIM ZRT.", role: "CEO", text: "With the SalesShark team it quickly became clear that we hadn't just picked a service provider — we picked a real strategic partner. Their system is transparent, their communication is professional, and every activity is measurable. SalesShark delivers concrete, accountable results — that's why we work with them." },
        ],
    },
    goal: {
        eyebrow: "Our mission",
        heading: "Deliver results — from better client care to new markets.",
        p1: "Deliver results, from better customer care to increased sales and opening completely new markets.",
        p2: "With us, you gain a reliable partner who supports your business growth step by step.",
        ctaContact: "Contact",
        ctaPresentation: "Company presentation",
    },
    about: {
        eyebrow: "About us",
        headingA: "We work with data,",
        headingB: "measure in results,",
        headingC: "and believe in human relationships.",
        story: {
            eyebrow: "Our story",
            p1: "In 2023, we founded GLOBEFOX International Staffing Agency in Bratislava — this is where the international sales focus began, and it is now the foundation of SalesShark.",
            p2: "Today we recruit across Hungary, Slovakia and Czechia, working with more than 50 partners, including manufacturing giants and market leaders. Alongside staffing, we also help our clients with company formation and accounting.",
            p3: "Our international experience and multilingual team enable us to represent our clients across borders at a truly professional level.",
        },
        stats: [
            { n: "2023", label: "Founded in Bratislava" },
            { n: "50+", label: "Active partners" },
            { n: "4", label: "Markets · HU / SK / CZ / AT" },
            { n: "5", label: "Languages · HU / SK / CZ / EN / DE" },
        ],
        pillars: {
            eyebrow: "Why us",
            headingA: "Four principles, one thread:",
            headingB: "results.",
            items: [
                { title: "Data-driven sales", text: "We build measurable pipeline from our proprietary country-structured company database — no guesswork." },
                { title: "Measurable outcomes", text: "Weekly status, KPIs, reports — you always know where the process stands and what's next." },
                { title: "Human relationships", text: "Trust, honest communication and consistent follow-up beat any „trick”." },
                { title: "Multilingual operations", text: "We represent our clients in Hungarian, Slovak, Czech, English and German, across borders." },
            ],
        },
        team: {
            eyebrow: "The team",
            heading: "The faces behind the process.",
            members: [
                {
                    role: "Managing Director / CEO · International Lawyer",
                    bio: [
                        "In 2023, we founded GLOBEFOX International Staffing Agency in Bratislava. I joined as an international lawyer, speaking four languages.",
                        "This allowed GLOBEFOX to be international from day one, and today we recruit in Hungary, Slovakia and Czechia. We now work with more than 50 partners, including manufacturing giants and market leaders.",
                        "Our international experience and multilingual team enable us to represent our clients across borders at a truly professional level.",
                    ],
                },
                {
                    role: "COO / Head of Operations · Co-founder",
                    bio: [
                        "I'm responsible for strategy and building the sales systems: my goal is for every client to receive a sales solution that generates real growth and stable customer acquisition.",
                        "On a daily basis I focus on campaign planning, data-driven optimisation and the processes that ensure our clients get more leads, meetings and new customers.",
                        "Our goal is for SalesShark to become the strongest, most reliable sales agency in the region — with real results, not promises.",
                    ],
                },
            ],
        },
    },
    contact: {
        eyebrow: "Contact",
        headingA: "Have a question?",
        headingB: "We answer within 24 hours.",
        ctaConsultation: "Free consultation",
        officeTitle: "Our offices",
        officeSubtitle: "Four offices across the region",
        offices: [
            { country: "HU", city: "2900 Komárom" },
            { country: "SK", city: "811 01 Bratislava" },
            { country: "HU", city: "9200 Mosonmagyaróvár" },
            { country: "SK", city: "943 01 Dunaszerdahely" },
        ],
        company: {
            name: "GLOBEFOX s.r.o.",
            addressLine1: "Sabinovska 9., Bratislava",
            addressLine2: "831 04, Slovakia",
            id: "Company ID: 55 100 376",
        },
    },
    form: {
        eyebrow: "Write to us",
        heading: "Leave a message — we reply within 24 hours.",
        labels: {
            name: "Name",
            email: "E-mail",
            phone: "Phone",
            company: "Company",
            message: "Message",
        },
        placeholders: {
            name: "John Smith",
            email: "john@company.com",
            phone: "+36 30 123 4567",
            company: "Acme Ltd.",
            message: "How can we help?",
        },
        companyHelper: "Optional — leave empty if you're an individual.",
        disclaimer:
            "By submitting you agree that we may contact you using the details provided.",
        submit: "Send message",
        sending: "Sending…",
        successTitle: "Message received.",
        successText: "We'll reply within 24 hours to the email address you provided.",
        errorTitle: "Sorry, we couldn't send it.",
        errorText: "Please try again, or contact us directly.",
    },
    faq: {
        eyebrow: "FAQ",
        headingA: "Frequently asked questions.",
        headingB: "Short, straight answers.",
        items: [
            { q: "In which countries do you operate?", a: "We are active in Hungary, Slovakia, Czechia and Austria. With our proprietary country-structured company database and multilingual team (Hungarian, Slovak, Czech, English, German) we help our partners enter and grow in these markets." },
            { q: "How big is your company database?", a: "Hungary: 16,000 companies, Slovakia: 13,000 companies, Austria: 47,000 companies, Czechia: 3,000 companies. The database is continuously updated and can be filtered by industry, company size, location and region." },
            { q: "In which languages do you handle outbound calls?", a: "We handle calls and follow-up in Hungarian, Slovak, Czech, English and German." },
            { q: "Are the email campaigns sent from your name?", a: "No. Email sequences are sent from your company email address, so you can directly monitor deliveries, replies and how meetings are progressing." },
            { q: "What's in the monthly report?", a: "Statuses, KPIs, next steps and a regular summary — so you always know where the pipeline stands." },
            { q: "How can we start working together?", a: "Book a 15-minute free consultation in the calendar. We'll map the target market, your current situation and recommend the best market-entry strategy." },
        ],
        notFoundEyebrow: "Can't find your answer?",
        notFoundHeading: "Ask us directly.",
        ctaConsultation: "Free consultation",
        ctaContact: "Contact",
    },
    footer: {
        eyebrow: "Start today",
        heading: "Let's talk about your next market.",
        subheading:
            "15-minute free consultation — measurable sales pipeline in HU / SK / CZ / AT markets.",
        cta: "Free consultation",
        tagline:
            "International Sales Agency. Results-driven customer acquisition, proprietary company database and a dedicated sales representative for HU / SK / CZ / AT markets.",
        contactHeading: "Contact",
        menuHeading: "Menu",
        copyright: (year) =>
            `© ${year} SalesShark · GLOBEFOX s.r.o. All rights reserved.`,
        roles: {
            antonia: "Antónia Somogyi · CEO",
            antal: "Antal Korcz · COO",
        },
    },
    services: {
        hero: {
            eyebrow: "Our services",
            headingA: "Digital and human sales, aligned —",
            headingB: "optimised for results.",
            subheading:
                "Six modules, one unified process — from market research to on-site representation.",
        },
        sideNavTitle: "Services",
        eyebrows: {
            dataDriven: "Data-driven sales",
            process: "Process",
            service: "Service",
        },
        ctaConsultation: "Free consultation",
        ctaContact: "Contact",
        bottomCta: {
            eyebrow: "Ready for the next step?",
            heading: "A 15-minute conversation about your next market.",
            subheading:
                "We'll show you how we build measurable pipeline using our own database in HU / SK / CZ / AT markets.",
        },
        sections: {
            cegadatbazis: {
                label: "Company database",
                title: "Company database",
                intro: [
                    "The database also contains short company profiles and website details.",
                    "If you've been Googling your potential target partners so far, this significantly accelerates market research and outreach.",
                    "Our name-based contact database is continuously updated.",
                ],
                statLabel: "companies",
                stats: [
                    { country: "Hungary", value: "16,000" },
                    { country: "Slovakia", value: "13,000" },
                    { country: "Austria", value: "47,000" },
                    { country: "Czechia", value: "3,000" },
                ],
                filtersTitle: "The following filters are available:",
                filters: ["Industry", "Company size (employee count)", "Location", "Region"],
            },
            email: {
                label: "Email marketing",
                title: "Email marketing",
                steps: [
                    { title: "Target audience selection from the company database", text: "Filtering by industry, region, company size." },
                    { title: "Mass email sequences", text: "Newsletters, introduction and proposal emails with scheduled follow-ups and unsubscribe option." },
                    { title: "Built-in appointment booking (CTA)", text: "With one click the recipient books a 15-minute meeting; the system auto-logs the event to your calendar." },
                    { title: "Real-time tracking and reporting", text: "Delivery, open, click, reply, booking — measurable per campaign and per recipient." },
                    { title: "From your own company email address", text: "Email sequences are sent from your corporate email, so you can directly monitor deliveries, replies and how meetings are progressing." },
                ],
            },
            phone: {
                label: "Outbound calling",
                title: "Outbound calling",
                items: [
                    { title: "Cold calls", text: "We call companies from the database using a well-crafted conversation script." },
                    { title: "Warmed-up calls", text: "We also call recipients who showed activity in the email campaign." },
                    { title: "Appointment setting", text: "Our goal is to reach the decision-maker and book a meeting for your salesperson." },
                    { title: "Telemarketing", text: "Onboarding + telephone selling + reporting." },
                    { title: "Multilingual outreach", text: "We handle calls and follow-up in Hungarian, Slovak, Czech, English and German." },
                    { title: "Handover and documentation", text: "Who was contacted, what was said, what the need is, next step, agreed appointment or rejection." },
                ],
            },
            staff: {
                label: "Staff placement",
                title: "Staff placement",
                items: [
                    { title: "Sales, telesales, admin or coordinator staff on demand", text: "Choose from CVs — occasional or long-term partners who represent your company as its „face” in HU / SK / CZ / EN / DE." },
                    { title: "System", text: "The team member uses our workflow (statuses, follow-up, meeting briefs, reports)." },
                    { title: "Full equipment provisioning on request", text: "Company car, phone and laptop, so work can start immediately at a professional level." },
                    { title: "Onboarding and training", text: "Preparation on the product and target market." },
                    { title: "Professional supervision", text: "Leadership and QA, weekly status/report + pipeline so we always know where we stand." },
                ],
            },
            marketing: {
                label: "Marketing",
                title: "Marketing",
                items: [
                    { title: "Branding", text: "Visual identity and logo design." },
                    { title: "Creative production", text: "Professional photos, videos, graphic assets, animations — in multiple languages." },
                    { title: "Sales collateral", text: "Presentations, proposals, one-pagers, business cards, promotional materials." },
                    { title: "Online ads (PPC)", text: "Campaign planning, setup, continuous optimisation (FB/IG/Google)." },
                    { title: "Social media content and campaigns", text: "Posts, ads." },
                    { title: "Measurement and reporting", text: "KPI tracking, learnings, tuning and scaling." },
                ],
            },
            expansion: {
                label: "Expansion",
                title: "Expanding? We'll help!",
                steps: [
                    { title: "Market research and target-market selection", text: "Country-level focus (industry, company size, region, competitive landscape)." },
                    { title: "Entry strategy and timeline", text: "Who to sell to, with what offer, through which channels, in which steps." },
                    { title: "Targeted company list and decision-maker contacts", text: "In the given country, built on our own database (HU / SK / CZ / AT)." },
                    { title: "Market-opening outreach campaigns", text: "Segmented introduction emails + multi-step follow-up." },
                    { title: "Multilingual calling and appointment setting", text: "In HU / SK / CZ / EN / DE, with qualified meetings." },
                    { title: "On-site representation", text: "Both occasional and long-term projects." },
                    { title: "Reporting and optimisation", text: "Measuring results, tuning, scaling to the best-performing segments." },
                    { title: "Optional: Company formation, translation, bank account, other administrative help", text: "Practical support for launch and operations." },
                ],
            },
        },
    },
    languageSwitcher: {
        label: "Language",
        aria: "Choose language",
    },
};

export default en;
